module.exports = __webpack_public_path__ + "img/sht.f008b5ba.jpg";